export const RIDE_DETAILS_TEXT = {
	error: 'Error',
	loading: 'Loading...',
	workAssignmentsList: 'Work assigments list',
};
